import { render, staticRenderFns } from "./ScenicSpot.vue?vue&type=template&id=0a6bf4c8&scoped=true&"
import script from "./ScenicSpot.vue?vue&type=script&lang=js&"
export * from "./ScenicSpot.vue?vue&type=script&lang=js&"
import style0 from "./ScenicSpot.vue?vue&type=style&index=0&id=0a6bf4c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6bf4c8",
  null
  
)

export default component.exports